import { useEffect } from "react";
import LocalDelivery from "components/jiffy/masthead-redesign2025/local-delivery/local-delivery";
import { useLocalDeliveryAddressEligible } from "@design-lab/shared/lib/config";
import { getPath } from "common/utils/ui/use_svg";

export function LocalDeliveryToggle() {
  const localDeliveryAddressEligible = useLocalDeliveryAddressEligible();

  useEffect(() => {
    LocalDelivery.init();
  }, []);

  return (
    <button
      className="js-local-delivery-modal-address-input js-local-delivery-toggle group relative flex w-full cursor-pointer items-center justify-between rounded-md border border-gray-300 bg-gray-100 px-2 py-[3px] pr-3 transition-colors duration-200 hover:bg-gray-200 data-[warning=true]:border-[#F0B100] data-[warning=true]:bg-yellow-50 data-[warning=true]:hover:bg-yellow-100 xl:py-2"
      data-testid="masthead-deliver-to-section"
      data-local-delivery-address-eligibility={localDeliveryAddressEligible}
      type="button"
    >
      <svg className="js-local-delivery-warning-icon group-data-[warning=true]:block! mr-1.5 hidden h-4 w-4 shrink-0 text-[#D08700]">
        <use xlinkHref={`${getPath()}#alert-triangle`} />
      </svg>
      <svg className="js-local-delivery-normal-icon group-data-[warning=true]:hidden! mr-1.5 block h-4 w-4 shrink-0 text-gray-900">
        <use xlinkHref={`${getPath()}#marker`} />
      </svg>
      <span className="js-local-delivery-address font-inter truncate pr-1 text-[13px] font-medium capitalize leading-[1.5em] text-gray-900 group-data-[warning=true]:text-amber-950" />
      <svg className="js-local-delivery-chevron h-2.5 w-2.5 shrink-0 text-gray-600 group-data-[warning=true]:text-amber-950">
        <use xlinkHref={`${getPath()}#chevron-down`} />
      </svg>
      <span className="js-local-delivery-warning-badge group-data-[warning=true]:block! absolute -right-2 -top-2 hidden h-3 w-3 rounded-full bg-red-600" />
    </button>
  );
}
